import React, { createContext } from 'react';
import GoogleFontLoader from 'react-google-font-loader';

export type PaymentTheme = {
    ['.Title']?: React.CSSProperties;
    ['.Subtitle']?: React.CSSProperties;
    ['.Button']?: React.CSSProperties;
    ['.Button:disabled']?: React.CSSProperties;
    ['.Button:icon']?: React.CSSProperties;
    ['.Button:hovered']?: React.CSSProperties;
    ['.Picker']?: React.CSSProperties;
    ['.Picker:disabled']?: React.CSSProperties;
    ['.Picker:hovered']?: React.CSSProperties;
    ['.Picker--selected']?: React.CSSProperties;
    ['.SummaryText']?: React.CSSProperties;
    ['.Logo']?: React.CSSProperties;
    ['.Font']?: React.CSSProperties;
};

export const PaymentThemeContext = createContext<PaymentTheme>({});

export const PaymentThemeProvider: React.FC<{
    data?: { theme: PaymentTheme };
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}> = ({ className = 'App', data, children, style }) => {
    const theme = data?.theme ?? {};

    const isFontFamilyDefined = !!theme['.Font']?.fontFamily;

    const wrapperDivStyle = {
        ...style,
    };

    return (
        <>
            {isFontFamilyDefined && theme['.Font']?.fontFamily && <GoogleFontLoader fonts={[{ font: theme['.Font'].fontFamily }]} />}
            <div className={className} style={wrapperDivStyle}>
                {children}
            </div>
        </>
    );
};
